import { LOAD_ALL_ENQUIRIES, LOAD_SINGLE_ENQUIRY } from "./EnquiryList.saga";

export const loadAllEnquiries = (payload) => ({
  type: LOAD_ALL_ENQUIRIES.LOADING,
  payload,
});

export const loadSingleEnquiry = (payload) => ({
  type: LOAD_SINGLE_ENQUIRY.LOADING,
  payload,
});
